interface Props {
    labelName: string;
    labelData: string | number | boolean;
    labelBoolean?: boolean;
    labelBooleanLabel?: boolean;
}

export default function ProfileTab({ labelName, labelData, labelBoolean = false, labelBooleanLabel }: Props) {
    return (
        <div className="rounded-lg border border-gray-200 bg-white px-3 py-2.5 transition hover:border-[#186cb2]/20 hover:bg-[#186cb2]/5">
            <p className="mb-1 text-[10px] font-medium uppercase tracking-wide text-gray-400">
                {labelName}
            </p>

            {labelBoolean ? (
                <div className={`text-xs font-semibold ${labelBooleanLabel ? "text-green-600" : "text-red-600"}`}>
                    {labelBooleanLabel ? "Active" : "Inactive"}
                </div>
            ) : (
                <div className="break-words text-xs font-semibold text-gray-700">
                    {labelData || "-"}
                </div>
            )}
        </div>
    );
}